import API from './api';

/*
|--------------------------------------------------------------------------
| GET TRADES / STAKES
|--------------------------------------------------------------------------
*/

export const getTrades = async (
    page = 1,
    search = '',
    perPage = 10
) => {

    try {
        // Build query parameters
        const params = {
            page: page,
            per_page: perPage
        };

        // Add search if provided
        if (search) {
            params.search = search;
        }

        console.log('Fetching trades with params:', params);

        // Make GET request with query parameters
        const response = await API.get('/admin/trades', { params });

        console.log('Trade API Response:', response.data);

        return response.data;

    } catch (error) {
        console.error('Trade API Error:', error.response?.data || error);

        // Check if token is expired or invalid
        if (error.response?.status === 401) {
            // Clear token and redirect to login if unauthorized
            localStorage.removeItem('token');
            window.location.href = '/login';
        }

        throw (
            error.response?.data || {
                status: false,
                message: 'Failed to fetch trades'
            }
        );
    }
};

/*
|--------------------------------------------------------------------------
| GET SINGLE TRADE DETAILS
|--------------------------------------------------------------------------
*/

export const getTradeDetails = async (tradeId) => {
    try {
        const response = await API.get(`/admin/trades/${tradeId}`);
        return response.data;
    } catch (error) {
        console.error('Trade details API Error:', error);
        throw (
            error.response?.data || {
                status: false,
                message: 'Failed to fetch trade details'
            }
        );
    }
};

/*
|--------------------------------------------------------------------------
| UPDATE TRADE STATUS
|--------------------------------------------------------------------------
*/

export const updateTradeStatus = async (tradeId, status) => {
    try {
        const response = await API.put(`/admin/trades/${tradeId}/status`, {
            status: status
        });
        return response.data;
    } catch (error) {
        console.error('Update trade status Error:', error);
        throw (
            error.response?.data || {
                status: false,
                message: 'Failed to update trade status'
            }
        );
    }
};

/*
|--------------------------------------------------------------------------
| EXPORT TRADES
|--------------------------------------------------------------------------
*/

export const exportTrades = (trades = []) => {
    try {
        // Create CSV content
        const headers = [
            'ID',
            'User ID',
            'User Name',
            'Wallet',
            'Package',
            'Stake Amount',
            'Token Name',
            'Token Amount',
            'Status',
            'Total Income',
            'Direct Income',
            'Level Income',
            'Transaction Hash',
            'Date'
        ];

        const csvContent = [
            headers.join(','),
            ...trades.map(trade => [
                trade.id,
                trade.user_id,
                `"${trade.user_name || 'N/A'}"`,
                `"${trade.user_wallet || 'N/A'}"`,
                `"${trade.package_name || 'N/A'}"`,
                trade.stake_amount,
                trade.token_name,
                trade.token_amount,
                trade.stake_status,
                trade.total_income,
                trade.direct_income,
                trade.level_income,
                `"${trade.txn_hash || 'N/A'}"`,
                `"${trade.joined || trade.created_at || 'N/A'}"`
            ].join(','))
        ].join('\n');

        // Create blob and download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = `trades-export-${new Date().toISOString().split('T')[0]}.csv`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);

        return true;

    } catch (error) {
        console.error('Export trades error:', error);
        return false;
    }
};

/*
|--------------------------------------------------------------------------
| EXPORT TRADES AS JSON
|--------------------------------------------------------------------------
*/

export const exportTradesAsJSON = (trades = []) => {
    try {
        const json = JSON.stringify(trades, null, 2);
        const blob = new Blob([json], { type: 'application/json' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = `trades-export-${new Date().toISOString().split('T')[0]}.json`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);

        return true;

    } catch (error) {
        console.error('Export trades JSON error:', error);
        return false;
    }
};